import React, { useEffect, useState } from "react";
import { useLazyGetActivityHistoryByIdQuery } from "../../services/users";
import { useParams } from "react-router-dom";
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const ActivityHistory = () => {
  const { _id } = useParams();
  const [rows, setRows] = useState<any>([]);

  const [getActivityHistoryById] = useLazyGetActivityHistoryByIdQuery();

  const fetchUserBooking = async () => {
    try {
      const result = await getActivityHistoryById({
        userId: _id,
        bookingType: "activity",
      }).unwrap();
      if ("data" in result && result.statusCode === 200) {
        const mappedBookings = result.data.booking.map((booking: any) => ({
          id: booking._id,
          bookingNumber: booking.bookingNumber,
          className: booking.subjectspecializations[0]?.name,
          bookingCost: booking.grandTotal,
          date: new Date(booking.bookingdetails[0]?.date).toLocaleDateString(),
          timeSlot: new Date(booking.bookingdetails[0]?.startTime).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
          activeStatus: mapBookingStatus(booking.bookingStatus),
        }));
        setRows(mappedBookings);
      } else {
        console.error("Failed to fetch user bookings:", result);
      }
    } catch (error) {
      console.error("Error fetching user bookings:", error);
    }
  };

  const mapBookingStatus = (bookingStatus: number) => {
    switch (bookingStatus) {
      case 1:
        return "PENDING";
      case 2:
        return "ACCEPTED";
      case 3:
        return "COMPLETED";
      case 4:
        return "REJECTED";
      case 5:
        return "CANCELLED";
      case 6:
        return "ONGOING";
      case 7:
        return "UPCOMING";
      default:
        return "UNKNOWN";
    }
  };

  useEffect(() => {
    if (_id) fetchUserBooking();
  }, [_id]);

  return (
    <Card sx={{ mt: 4 }} className="cards">
      <Box className="custom_tabs">
        <h2 className="mn_hdng">Activity History</h2>
      </Box>
      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Booking id</TableCell>
              <TableCell>Class Name</TableCell>
              <TableCell>Booking cost</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Time slot</TableCell>
              <TableCell>Active Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7}>
                  <Typography style={{marginLeft:400}}>No activity history available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((booking: any, index: number) => (
                <TableRow key={booking.id}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell>{booking.bookingNumber}</TableCell>
                  <TableCell>{booking.className}</TableCell>
                  <TableCell>${booking.bookingCost}</TableCell>
                  <TableCell>{`Date: ${booking.date}`}</TableCell>
                  <TableCell>{`Time slot: ${booking.timeSlot}`}</TableCell>
                  <TableCell>{booking.activeStatus}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default ActivityHistory;
